import { render, staticRenderFns } from "./CASEItemTileExpanded.vue?vue&type=template&id=54100f01"
import script from "./CASEItemTileExpanded.vue?vue&type=script&lang=js"
export * from "./CASEItemTileExpanded.vue?vue&type=script&lang=js"
import style0 from "./CASEItemTileExpanded.vue?vue&type=style&index=0&id=54100f01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports